export let Action;
(function (_Action) {
  let Type = /*#__PURE__*/function (Type) {
    Type["AddManagerButtonClick"] = "ADD_MANAGER_BUTTON_CLICK";
    Type["AddOwnerButtonClick"] = "ADD_OWNER_BUTTON_CLICK";
    Type["CloseDialog"] = "CLOSE_DIALOG";
    Type["ContinueButtonClick"] = "CONTINUE_BUTTON_CLICK";
    Type["DeleteIndividualSubmitRequest"] = "DELETE_INDIVIDUAL_SUBMIT_REQUEST";
    Type["EditIndividualClick"] = "EDIT_INDIVIDUAL_CLICK";
    Type["IndividualSubmitRequest"] = "INDIVIDUAL_SUBMIT_REQUEST";
    Type["CiInitialize"] = "CI_INITIALIZE";
    Type["OpenDialog"] = "OPEN_DIALOG";
    Type["UpdateIndividualsResponse"] = "UPDATE_INDIVIDUALS_RESPONSE";
    Type["UpdateIndividualsError"] = "UPDATE_INDIVIDUALS_ERROR";
    return Type;
  }({});
  _Action.Type = Type;
})(Action || (Action = {}));
export const addManagerButtonClickAction = () => ({
  type: Action.Type.AddManagerButtonClick
});
export const addOwnerButtonClickAction = () => ({
  type: Action.Type.AddOwnerButtonClick
});
export const closeDialogAction = () => ({
  type: Action.Type.CloseDialog
});
export const continueButtonClickAction = () => ({
  type: Action.Type.ContinueButtonClick
});
export const deleteIndividualSubmitRequestAction = individualId => ({
  type: Action.Type.DeleteIndividualSubmitRequest,
  individualId
});
export const editIndividualClickAction = individualId => ({
  type: Action.Type.EditIndividualClick,
  individualId
});
export const individualSubmitRequestAction = individual => ({
  type: Action.Type.IndividualSubmitRequest,
  individual
});
export const initializeAction = ({
  businessName,
  requireManager,
  hasSignificantOwners,
  existingIndividuals
}) => ({
  type: Action.Type.CiInitialize,
  businessName,
  requireManager,
  hasSignificantOwners,
  existingIndividuals
});
export const openDialogAction = (screen, individual) => ({
  type: Action.Type.OpenDialog,
  screen,
  individual
});
export const updateIndividualsResponse = newIndividuals => ({
  type: Action.Type.UpdateIndividualsResponse,
  newIndividuals
});
export const updateIndividualsError = errors => ({
  type: Action.Type.UpdateIndividualsError,
  errors
});